import i18n from '../../i18n.js';
import { isTaxNumberValid } from '../../utils/validators';

const validationFunctions = {
  client_id: order => {
    const value = order['client_id'];

    if (!value) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    return '';
  },
  principal_id: order => {
    const value = order['principal_id'];

    if (!value) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    return '';
  },
  company_name: order => {
    const value = order['company_name'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    return '';
  },
  tax_number: order => {
    const value = order['tax_number'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if (value !== '0000000000' && !isTaxNumberValid(value)) {
      return i18n.global.t('errors.taxNumberInvalid');
    }

    return '';
  },
  principal_contact_person: order => {
    const value = order['principal_contact_person'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  principal_phone_number: order => {
    const value = order['principal_phone_number'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  principal_email_address: order => {
    const value = order['principal_email_address'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  customer_contact_person: order => {
    const value = order['customer_contact_person'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  customer_phone_number: order => {
    const value = order['customer_phone_number'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  customer_email_address: order => {
    const value = order['customer_email_address'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  customer_address: order => {
    const value = order['customer_address'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  subject_of_financing: order => {
    const value = order['subject_of_financing'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  offer_value: order => {
    let value = order['offer_value'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if (value.replace(/[^\d\.,]/g,'') !== value) {
      return i18n.global.t('errors.fieldMustBeFloat');
    }

    if ((value.match(/[\,.]/g) || []).length > 1) {
      return i18n.global.t('errors.fieldMustBeFloat');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    const pos = Math.max(value.indexOf('.'), value.indexOf(','));

    if (pos === -1 || pos === value.length -1) {
      value += '00';
    } else if (pos === value.length -2) {
      value += '0';
    }

    value = value.replace(/[\.,]/g, '');

    const intValue = BigInt(value);
    const maxValue = BigInt(2 ** 64) - BigInt(1);

    if (intValue > maxValue) {
      return i18n.global.t('errors.fieldOutOfRangeUnsignedBigInt');
    }

    return '';
  },
  customer_type: order => {
    const value = order['customer_type'];

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  transaction_type: () => {
    return '';
  }
};

function validateSingleField(order, key) {
  return validationFunctions[key](order);
}

function validateAllFields(order) {
  const errors = {};

  Object.keys(validationFunctions).forEach(key => {
    const message = validationFunctions[key](order);

    if (message.length > 0) {
      errors[key] = message;
    }
  });

  return errors;
}

export { validateSingleField, validateAllFields };
